import { inject, Injectable } from '@angular/core';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { environment } from 'src/environments/environment';
import { BathroomHbmService } from '../configurators-2d/applications/bathroom-hbm.service';
import { KitchenService } from '../configurators-2d/applications/kitchen.service';
import { StorageService } from '../configurators-2d/applications/storage.service';
import { HbmConfigurator } from './hbm-configurator';

/** Référentiel des configurateurs 3D HomeByMe (Cuisine, Rangement, Salle de bain). */
@Injectable({ providedIn: 'root' })
export class HbmConfiguratorRegistry {
  private readonly kitchenService = inject(KitchenService);
  private readonly storageService = inject(StorageService);
  private readonly bathroomHbmService = inject(BathroomHbmService);

  private readonly configurators: readonly HbmConfigurator[] = [
    {
      context: CONFIG_CONTEXT.KITCHEN,
      distribID: environment.byMe.kitchen.distribID,
      startIndex: 3,
      load: uuid => this.kitchenService.loadKitchenConfigurationFromHBM(uuid),
      getTunnel: uuid => this.kitchenService.getLiteKitchenConfiguration(uuid),
      duplicateTunnel: input => this.kitchenService.duplicateKitchen(input),
    },
    {
      context: CONFIG_CONTEXT.STORAGE,
      distribID: environment.byMe.storage.distribID,
      startIndex: 2,
      load: uuid => this.storageService.loadStorageConfigurationFromHBM(uuid),
      getTunnel: uuid => this.storageService.getLiteStorageConfiguration(uuid),
      duplicateTunnel: input => this.storageService.duplicateStorage(input),
    },
    {
      context: CONFIG_CONTEXT.BATHROOM,
      distribID: environment.byMe.bathroom.distribID,
      startIndex: 0,
      load: uuid => this.bathroomHbmService.loadBathroomHbmConfigurationFromHBM(uuid),
      getTunnel: uuid => this.bathroomHbmService.getLiteBathroomHbmConfiguration(uuid),
      duplicateTunnel: input => this.bathroomHbmService.duplicateBathroomHbm(input),
    },
  ];

  /** Retourne le configurateur HomeByMe du contexte, ou `undefined` si le contexte n'est pas HomeByMe. */
  byContext(context: string): HbmConfigurator | undefined {
    return this.configurators.find(configurator => configurator.context === context);
  }

  /** Retourne le configurateur HomeByMe de l'identifiant de distribution, ou `undefined` s'il n'est pas HomeByMe. */
  byDistributionID(distribID: string): HbmConfigurator | undefined {
    return this.configurators.find(configurator => configurator.distribID === distribID);
  }
}
